<template>
  <div :class="classes">
    <pt-page-title title="积分发放列表"  isSearch  @search="search" @emptySearch="emptySearch" :searchKey="searchKey" @searchNo="searchNo">
        <template slot="before-right">
        <el-button  type="primary" @click="grantReward" v-if="HAS_PERM_MALLSALES_MANUAL_REWARD">向指定用户发放奖励</el-button>
          <el-button type="primary" @click="batchReview" v-if="isBatchAdutit">批量审核</el-button>
          </template>
    </pt-page-title>
    <pt-page-menu-filter :tabs="awardStatusTabs" v-model="selectTab" state="status"></pt-page-menu-filter>
    <pt-page-factor-filter :labels="filterLabels" v-model="params" isQueryRouter ref="filter" @Filter="Filter">
        <template>
          <el-button type="primary" @click="Filter()">筛选</el-button>
          <el-button type="primary" @click="exportPointsReward" :loading="exportLoading">导出</el-button>
            <el-button type="primary" @click="exportHistoryPointsReward">导出历史</el-button>
          <el-button type="text" @click="cleanParams">清除筛选条件</el-button>
        </template>
    </pt-page-factor-filter>
    <pt-points-reward-table :tableLabels="integralRewardLabels" :class="$style['manual-reward-table']" ref="table" :paramsData="paramsData" :isFromRouter="isFromRouter"
    @select="select" @selectAll="selectAll" :isShowSelect="isShowSelect">
      <template>
          <el-table-column label="状态"  :key="Math.random()">
              <template slot-scope="scope">
                  <div :style="'color:'+(theRowIsReject(scope.row)?'#FF0000':'')">
                      {{scope.row.audit_status}}
                  </div>
              </template>
          </el-table-column>
          <el-table-column :key="Math.random()" v-if="selectTab==='COMPLETED'" :label="'审核时间'">
            <template slot-scope="scope" >
              {{scope.row.approval_date}}
            </template>
          </el-table-column>
          <el-table-column  :key="Math.random()" label="操作">
              <template slot-scope="scope">
                  <el-button type="text" @click="getRewardDetail(scope.row)">详情</el-button>
                  <el-button type="text" v-if="scope.row.status==='WAITING_FOR_APPROVAL'&&HAS_PERM_MANUAL_CUSTOMER_AUDIT" @click="rewardAudit(scope.row)" >审核</el-button>
              </template>
          </el-table-column>
        </template>
    </pt-points-reward-table>
    <el-dialog :visible="is_dialog" :title="dialog_title" :class="$style['review-coupon-dialog']" @close="closeDialog">
      <award-grant-review v-if="is_review" :selectRows="selectRows" :statisticsData="statisticsData" isManualReward
      @getTableData="getTableData" @closeDialog="closeDialog" :auditStatus="auditStatus" :selectTab="selectTab" :isIntegral="true"></award-grant-review>
      <award-result v-if="isShowResult" :resultContent="resultContent" @closeDialog="closeDialog"></award-result>
    </el-dialog>
  </div>
</template>

<script>
// 组件class前缀
import ptPointsRewardTable from './pt-points-reward-table/withData'
import { integralRewardLabels, awardStatusTabs, filterLabels } from './points-reward-option'
import awardResult from 'cps/new-to-old-audit/pt-award-audit/award-result'
import { hasPermissions } from 'utils/permissions'
import awardGrantReview from './points-reward-review'
// 手动发放奖励审核权限
import { emptyObject } from '@/utils/lifebankUtils'
const PERM_MALLSALES_MANUAL_REWARD = 'PERM_MALLSALES_MANUAL_REWARD'// 手动发放奖励发放权限
const PERM_MALLSALES_MANUAL_REWARD_AUDIT = 'PERM_MALLSALES_MANUAL_REWARD_AUDIT'// 手动发放奖励财务审核权限
const PERM_MANUAL_CUSTOMER_AUDIT = 'PERM_MANUAL_CUSTOMER_AUDIT'// 手动发放奖励客服审核权限
const approvalDateFilter = {
  label: '审核时间',
  type: 'time-slot',
  value: 'approvalDate',
  startName: 'auditStartTime',
  endName: 'auditEndTime'
}
// 组件class前缀
const prefixCls = 'pt-points-reward'

export default {
  name: 'pt-points-reward',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    is_dialog: {
      get: function () {
        return this.is_review || this.isShowResult
      },
      set: function (val) {
        this.is_review = val
        this.isShowResult = val
      }
    },
    HAS_PERM_MALLSALES_MANUAL_REWARD () {
      // 判断用户是否拥有手动发放奖励发放的权限
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_MALLSALES_MANUAL_REWARD)
    },
    HAS_PERM_MALLSALES_MANUAL_REWARD_AUDIT () { // 财务审核权限
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_MALLSALES_MANUAL_REWARD_AUDIT)
    },
    HAS_PERM_MANUAL_CUSTOMER_AUDIT () { // 手动发放奖励客服审核权限
      return this.$auth.user() && this.$auth.user().permissions && hasPermissions(this.$auth.user().permissions, PERM_MANUAL_CUSTOMER_AUDIT)
    },
    // 是否可批量操作
    isBatchAdutit () {
      return (this.selectTab === 'WAITING_FOR_APPROVAL' && this.HAS_PERM_MANUAL_CUSTOMER_AUDIT) || (this.selectTab === 'SALES_COMPLETED' && this.HAS_PERM_MALLSALES_MANUAL_REWARD_AUDIT)
    },
    // 是否显示首列选择框
    isShowSelect () {
      return this.isBatchAdutit
    },
    // 是否需要筛选审核时间
    isShowApprovalTime () {
      return this.selectTab === 'COMPLETED'
    },
    tableData () {
      return this.$refs.table.tableData
    }
  },
  props: {
    statisticsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isReview: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ptPointsRewardTable,
    awardResult,
    awardGrantReview
  },
  data () {
    return {
      integralRewardLabels: integralRewardLabels,
      awardStatusTabs: awardStatusTabs,
      selectTab: 'ALL',
      params: null,
      paramsData: {},
      is_review: this.isReview,
      isShowResult: false,
      resultContent: null,
      dialog_title: null,
      isBatch: false,
      selectRows: [],
      filterLabels: filterLabels,
      isFromRouter: false,
      searchKey: null,
      auditStatus: null
    }
  },
  watch: {
    selectTab (val) {
      emptyObject(this.paramsData)
      emptyObject(this.params)
      if (val === 'ALL') {
        this.paramsData = {}
      }
      if (val !== 'ALL') {
        this.$set(this.paramsData, 'status', val)
      }
      this.filterLabelsData()
    },
    isReview (val) {
      this.dialog_title = '手动发放积分审核'
      this.$set(this, 'is_review', val)
    }
  },
  methods: {
    exportPointsReward () {
      let paramsData = this.paramsFunction()
      paramsData = { ...paramsData, ...this.paramsData }
      if (this.tableData && this.tableData.length) {
        this.$confirm('导出操作需要花费一定时间，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可。', '导出提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info' }).then(_ => {
          this.$emit('pointsRewardExport', paramsData)
        })
      } else {
        this.$alert('该列表暂无可导出记录', '导出提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: action => {
          }
        })
      }
    },
    exportHistoryPointsReward () {
      this.$router.push('/export-history/points-reward?name=points_reward_export')
    },
    filterLabelsData () {
      // 筛选条件是否包含审核时间
      let isArrayInclundApproval = JSON.stringify(this.filterLabels).indexOf(JSON.stringify(approvalDateFilter)) < 0
      if (this.isShowApprovalTime) {
        if (isArrayInclundApproval) {
          if (this.selectTab === 'COMPLETED') {
            approvalDateFilter.label = '审核时间'
          }
          this.filterLabels.splice(1, 0, approvalDateFilter)
        }
      } else {
        if (!isArrayInclundApproval) {
          this.filterLabels.forEach((item, index) => {
            if (item.value === 'approvalDate') {
              this.filterLabels.splice(index, 1)
            }
          })
        }
      }
    },
    theRowIsReject (row) {
      return row.status === 'REJECTED'
    },
    search (val) {
      this.searchKey = val
      this.isFromRouter = false
      this.paramsData = { keyword: val }
    },
    emptySearch () {
      this.searchKey = null
      this.$delete(this.queryParams, 'keyword')
    },
    searchNo (val) {
      this.searchKey = val
    },
    paramsFunction () {
      for (var key in this.params) {
        if (key === 'grantDate') {
          this.$delete(this.params[key], 'index')
          this.params = { ...this.params, ...this.params[key] }
          this.$delete(this.params, key)
        }
        if (key === 'grantMoney') {
          this.$delete(this.params[key], 'index')
          this.params = { ...this.params, ...this.params[key] }
          this.$delete(this.params, key)
        }
        if (key === 'approvalDate') {
          this.$delete(this.params[key], 'index')
          this.params = { ...this.params, ...this.params[key] }
          this.$delete(this.params, key)
        }
      }
      let paramsData = {}
      if (this.params.status !== 'ALL') {
        paramsData = { ...paramsData, ...this.params }
      } else {
        this.$delete(this.params, 'status')
        paramsData = { ...paramsData, ...this.params }
      }
      return paramsData
    },
    Filter (isFromRouter) {
      this.isFromRouter = isFromRouter
      this.paramsData = this.paramsFunction()
      if (!isFromRouter) {
        this.$refs.filter.getAddRouter(this.paramsData)
      }
    },
    cleanParams () {
      emptyObject(this.params)
      for (var key in this.paramsData) {
        if (key !== 'status') {
          this.$delete(this.paramsData, key)
        }
      }
      this.Filter()
    },
    clearSelection () {
      this.$refs.table.clearSelection()
    },
    batchReview () {
      if (this.selectRows && this.selectRows.length > 0) {
        let ids = []
        this.$confirm('您是否确认批量审核', '确认审核', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning' }).then(_ => {
          this.selectRows.forEach(item => {
            this.auditStatus = item.status
            ids.push(item.id)
            this.is_review = true
          })
          this.isBatch = true
          // this.$emit('batchReview', ids, this.auditStatus)
        })
      } else {
        this.$message.error('请勾选需要审核奖励记录')
      }
    },
    select (row) {
      this.selectRows = []
      row.forEach(item => {
        this.selectRows.push(item)
      })
    },
    selectAll (rows) {
      this.selectRows = []
      rows.forEach(item => {
        this.selectRows.push(item)
      })
    },
    getTableData () {
      this.$nextTick(_ => {
        this.$refs.table.getTableData()
      })
    },
    grantReward () {
      this.$router.push('/points-grant-form')
    },
    getRewardDetail (row) {
      this.$router.push('/points-reward-detail/' + row.id)
    },
    rewardAudit (row) {
      this.isBatch = true
      this.selectRows = []
      this.selectRows.push(row)
      let ids = []
      this.auditStatus = row.status
      ids.push(row.id)
      this.$emit('rewardAudit', ids, this.auditStatus)
    },
    closeDialog (val, showResult, resultContent) {
      this.is_dialog = false
      this.is_review = false
      this.$emit('closeDialog')
      if (val) {
        this.$refs.table.getTableData()
      }
      if (showResult) {
        this.isShowResult = true
        this.resultContent = resultContent
      }
    }
  },
  created () {
    this.filterLabelsData()
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.manual-reward-table{
    :global
    .el-button{
        margin-left: 0;
        margin-right:10px;
    }
}
</style>
